export function generateRandomToken(entropy, encoder) {
    if (entropy <= 0 || isNaN(entropy)) {
        throw new Error("The entropy of a random ID must be at least 1");
    }
    const entropyInBytes = Math.ceil(entropy / 8);
    const randomBytes = crypto.getRandomValues(new Uint8Array(entropyInBytes));
    if (encoder) {
        return encoder.encode(randomBytes);
    }
    return randomBytes;
}
//# sourceMappingURL=random.js.map